const LOADING = {
  titleKey: "components/utils/loading:title",
  messageKey: "components/utils/loading:messages",
};

const ALERT = {
  warningTitle:
    "AI 마법사가 마법으로 그림을 그리지만, 가끔은 마법이 잘못되어 그림이 이상해질 수 있어요.",
  blackScreenTips: "검은 배경그림이 나오면, 배경그림 새로만들기를 해주세요.",
};

const ERROR = {
  busy: "AI 마법사가 너무 바빠서 잠시 쉬고 있어요.",
  lack: "체험에 필요한 마법콩이 부족합니다. 마법콩을 충전해주세요.",
};

const MAKING_CUSTOM_STEPS = [
  "story",
  "picture",
  "gender",
  "name",
  "drawType",
  "option",
  "genre",
];

module.exports = { LOADING, ALERT, ERROR, MAKING_CUSTOM_STEPS };
